import TabsAccessibility from './mixins/tabAccessibility';

$(document).ready(function() {
    resizeHeader();
    
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();

    document.querySelectorAll('[role=tablist]').forEach( function(list) {
        new TabsAccessibility(list);
    });

    $('.nav-material-tabs').each(prepareMaterialTabs);

    if( $('#tariff-card-deck').length !== 0 ) {

        $('#tariff-card-deck').find('#max_allowed_users_basic').change(function() {
            $('#tariff-card-deck #price_basic').text($(this).val());
        });

        $('#tariff-card-deck').find('#max_allowed_users_professional').change(function() {
            $('#tariff-card-deck #price_professional').text($(this).val());
        });
    } 

    prepareCustomInputs();
    addWaveRipples();
});

$(function(){
    
    if (location.hash) {
        $("a[href='" + location.hash + "']").tab("show");
    }

    // adding events to body
    $(document.body).on("click", "a[data-toggle]", function(event) {
        const hash = this.getAttribute("href");
        if(history.pushState) {
            history.pushState(null, null, hash);
        }
        else {
            location.hash = hash;
        }
    });

    $(document.body).on("click", ".navbar-toggler", function(event) {
        const beforehandStatus = $(this).attr('aria-expanded');
        const navbar = $(this).closest('.app-header.header-transition');

        if (navbar.length) {
            $(navbar).toggleClass('navbar-shown', beforehandStatus);
        }
    });

    // why is this here??
    $.navigation = $('nav > ul.nav');

});

window.addEventListener('scroll', function(e) {
    resizeHeader();
});

window.addEventListener('resize', function(e) {
    $('.nav-material-tabs').each(function() {
        var $tabs = $(this),
            $activeTab = $tabs.find('.nav-link.active');

        moveMaterialSlider($tabs, $activeTab);
    });
});

window.focusError = function(id) {
    var headerHeight = parseInt($('#pageHeader').outerHeight()),
        indent = 32; // 2rem

    $('html, body').animate({ scrollTop: ($('#'+id).offset().top - indent - headerHeight) }, 'slow');
    $('#'+id).focus();
}

function resizeHeader() {
    $('.app-header:not(.header-backend)').toggleClass('header-scrolltop', document.documentElement.scrollTop <= 55);
}

function prepareCustomInputs() {
    $('.custom-file-input').on('change', function() {
        var fileName = $(this).val().split('\\').pop();
        $(this).next('.custom-file-label').html(fileName);
    })
}

function addWaveRipples() {
    $('.btn').not('.btn-link').on('click', createRipple);

    function createRipple(e) {
        let ripples = this.getElementsByClassName('wave-ripple');
        while(ripples.length > 0) {
            ripples[0].remove();
        }

        let circle = document.createElement('div');
        circle.style["position"] = 'absolute';
        this.appendChild(circle);

        let d = Math.max(this.clientWidth, this.clientHeight);
        let eRect = this.getBoundingClientRect()

        circle.style.width = circle.style.height = d + 'px';
        circle.style.left = e.clientX - eRect.left - d / 2 + 'px';
        circle.style.top = e.clientY - eRect.top - d / 2 + 'px';

        circle.classList.add('wave-ripple');
    }
}

function prepareMaterialTabs() {
    let $this = $(this), // this = .nav-material-tabs
        $activeTab = $this.find('.nav-link.active');

    let $slider = $('<div class="tab-active-bar"></div>').appendTo($this);
    moveMaterialSlider($this, $activeTab, $slider);

    $this.find('.nav-link').on('show.bs.tab', function (event) {
        let $tabs = $(event.target);
        moveMaterialSlider($tabs.closest('.nav-material-tabs'), $tabs);
    });
}

function moveMaterialSlider($tabs, $activeTab, $slider = null) {
    if($activeTab.length) {
    var $slider = $slider || $tabs.find('.tab-active-bar'),
        width = $activeTab.closest('li').width(),
        left = $activeTab.offset().left - $tabs.offset().left;

        $slider.css({
            "width": width + "px",
            "left": left + "px"
        });
    }
}
